var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-name ma-4"},[_c('h3',{staticClass:"subtitle text-center"},[_vm._v(" "+_vm._s(_vm.getUserName)+", ")]),_c('p',{staticClass:"text-center"},[_vm._v("detta provar vi idag:")])])}
var staticRenderFns = []

export { render, staticRenderFns }